import { render, staticRenderFns } from "./HomeAssist.vue?vue&type=template&id=18a98be9&"
import script from "./HomeAssist.vue?vue&type=script&lang=js&"
export * from "./HomeAssist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports